(() => {
  const $ = (s) => document.querySelector(s);
  const dr = $('#dr'), bg = $('#drBg');
  if (!dr) return;
  const tl = (k) => (k / 100).toLocaleString('tr-TR', { maximumFractionDigits: 2 }) + ' TL';
  const esc = (s) => String(s).replace(/[&<>"]/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]));
  const cmp = {};
  const karsi = async (h) => (cmp[h] ??= fetch(`/products/${h}.js`).then((r) => r.json()).then((p) => Object.fromEntries(p.variants.map((v) => [v.id, v.compare_at_price || 0]))).catch(() => ({})));
  let son = null;

  // Çorap paketleri: sepetteki toplam çift sayısı her değişimde en ucuz paket bileşimine (8, 4, 2) çevrilir.
  // Böylece 2'li paketten 2 tane = 4'lü paket fiyatı. Her satırdaki renk/beden seçimi "Çift seçimi" özelliğinde korunur.
  const COR = 'alpaka-kislik-corap';
  let urun;
  const urunAl = () => (urun ??= fetch(`/products/${COR}.js`).then((r) => r.json()));
  const boy = (t) => parseInt(t, 10) || 0;
  const json = (u, b) => fetch(u, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(b) }).then((r) => r.json());
  const ciftler = (it) => {
    const n = boy(it.variant_options[0]), tek = [];
    String((it.properties || {})['Çift seçimi'] || '').split(', ').forEach((g) => { const m = g.match(/^(\d+)× (.+)$/); if (m) for (let i = 0; i < +m[1]; i++) tek.push(m[2]); });
    while (tek.length < n) tek.push(`${it.variant_options[1]} ${it.variant_options[2]}`);
    tek.length = n;
    return Array.from({ length: it.quantity }, () => tek).flat();
  };
  const paketle = (n) => { const r = []; for (const b of [8, 4, 2]) while (n >= b) { r.push(b); n -= b; } return r; };
  const fiyat = (p, b) => (p.variants.find((v) => boy(v.option1) === b) || {}).price || 0;
  const kur = async (S, liste) => {
    const p = await urunAl();
    let i = 0;
    const items = paketle(liste.length).map((b) => {
      const pc = liste.slice(i, (i += b)), [renk, ...bd] = pc[0].split(' ');
      const v = p.variants.find((x) => boy(x.option1) === b && x.option2 === renk && x.option3 === bd.join(' ')) || p.variants.find((x) => boy(x.option1) === b);
      const g = {}; pc.forEach((k) => (g[k] = (g[k] || 0) + 1));
      return { id: v.id, quantity: 1, properties: { 'Çift seçimi': Object.entries(g).map(([k, q]) => `${q}× ${k}`).join(', ') } };
    });
    if (S.length) await json('/cart/update.js', { updates: Object.fromEntries(S.map((x) => [x.key, 0])) });
    if (items.length) await json('/cart/add.js', { items });
  };
  // sepet en ucuz bileşimde değilse düzeltir; değiştiyse true
  const duzenle = async (c) => {
    const S = c.items.filter((x) => x.handle === COR);
    if (!S.length) return false;
    const simdi = S.flatMap((x) => Array(x.quantity).fill(boy(x.variant_options[0]))).sort().join();
    const liste = S.flatMap(ciftler);
    if (paketle(liste.length).sort().join() === simdi) return false;
    await kur(S, liste);
    return true;
  };

  const ciz = async () => {
    let c = await fetch('/cart.js').then((r) => r.json());
    if (await duzenle(c)) c = await fetch('/cart.js').then((r) => r.json());
    const cs = c.items.filter((x) => x.handle === COR).reduce((t, x) => t + boy(x.variant_options[0]) * x.quantity, 0);
    $('#drN').textContent = c.item_count;
    document.querySelectorAll('.cc').forEach((e) => { e.textContent = c.item_count; e.hidden = !c.item_count; });
    if (!c.items.length) { $('#drBody').innerHTML = '<p class="dr-bos">Sepetin boş.</p>'; $('#drFt').hidden = true; filtrele(c); return; }
    let kazanc = 0;
    const satir = await Promise.all(c.items.map(async (it) => {
      const k = ((await karsi(it.handle))[it.variant_id] || 0) * it.quantity;
      if (k > it.final_line_price) kazanc += k - it.final_line_price;
      const ozel = Object.entries(it.properties || {}).filter(([a, b]) => b && !a.startsWith('_')).map(([a, b]) => `<small>${esc(a)}: ${esc(b)}</small>`).join('');
      return `<div class="dr-it"><img src="${it.image ? it.image.replace(/(\.\w+)(\?|$)/, '_160x$1$2') : ''}" alt="" width="72" height="72">
        <div class="dr-d"><b>${esc(it.product_title)}</b>${it.product_has_only_default_variant ? '' : `<small class="m">${esc(it.handle === COR ? it.variant_options[0] : it.variant_title)}</small>`}${ozel}
          ${it.handle === COR
            ? `<div class="dr-q"><button type="button" data-ck="${it.key}" data-cd="-2" aria-label="2 çift azalt"${cs <= 2 ? ' disabled title="En az 2 çift"' : ''}>−</button><span>${boy(it.variant_options[0]) * it.quantity} çift</span><button type="button" data-ck="${it.key}" data-cd="2" aria-label="2 çift ekle">+</button><button type="button" class="dr-sil" data-k="${it.key}" data-q="0">Kaldır</button></div>`
            : `<div class="dr-q"><button type="button" data-k="${it.key}" data-q="${it.quantity - 1}" aria-label="Azalt">−</button><span>${it.quantity}</span><button type="button" data-k="${it.key}" data-q="${it.quantity + 1}" aria-label="Artır">+</button><button type="button" class="dr-sil" data-k="${it.key}" data-q="0">Kaldır</button></div>`}</div>
        <div class="dr-p m">${tl(it.final_line_price)}${k > it.final_line_price ? `<s>${tl(k)}</s>` : ''}</div></div>`;
    }));
    let ipucu = '';
    if (cs) {
      const p = await urunAl(), top = (n) => paketle(n).reduce((t, b) => t + fiyat(p, b), 0);
      if (top(cs + 2) <= top(cs)) ipucu = `<p class="dr-ip">2 çift daha ekle, ${cs + 2} çifti ${tl(top(cs + 2))}'ye al${top(cs + 2) < top(cs) ? ` (${tl(top(cs) - top(cs + 2))} daha az)` : ''}. <button type="button" data-ck="${c.items.find((x) => x.handle === COR).key}" data-cd="2">+2 ÇİFT EKLE</button></p>`;
    }
    $('#drBody').innerHTML = satir.join('') + ipucu;
    $('#drKz').hidden = !kazanc; $('#drKzV').textContent = '-' + tl(kazanc);
    $('#drSub').textContent = tl(c.total_price);
    $('#drFt').hidden = false;
    filtrele(c);
  };
  const filtrele = (c) => {
    const var_ = new Set(c.items.map((i) => i.handle));
    let kalan = 0;
    document.querySelectorAll('.dr-up').forEach((u) => { u.hidden = var_.has(u.dataset.h); if (!u.hidden) kalan++; });
    const ups = $('#drUps'); if (ups) ups.hidden = !kalan;
  };
  const ac = async () => {
    son = document.activeElement;
    bg.hidden = false; dr.removeAttribute('inert'); dr.setAttribute('aria-hidden', 'false');
    requestAnimationFrame(() => { dr.classList.add('on'); bg.classList.add('on'); });
    document.documentElement.style.overflow = 'hidden';
    $('#drX').focus();
    await ciz();
  };
  const kapat = () => {
    dr.classList.remove('on'); bg.classList.remove('on');
    dr.setAttribute('aria-hidden', 'true'); dr.setAttribute('inert', '');
    document.documentElement.style.overflow = '';
    setTimeout(() => (bg.hidden = true), 250);
    son?.focus?.();
  };
  const degis = async (key, q) => {
    await fetch('/cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ id: key, quantity: q }) });
    await ciz();
  };
  dr.addEventListener('click', async (e) => {
    const b = e.target.closest('button'); if (!b) return;
    if (b.dataset.k) { b.disabled = true; await degis(b.dataset.k, +b.dataset.q); }
    if (b.dataset.ck) {
      b.disabled = true;
      const c = await fetch('/cart.js').then((r) => r.json());
      const S = c.items.filter((x) => x.handle === COR);
      const liste = S.flatMap((x) => { const l = ciftler(x); if (x.key !== b.dataset.ck) return l; return +b.dataset.cd > 0 ? [...l, l[l.length - 1], l[l.length - 1]] : l.slice(0, -2); });
      await kur(S, liste);
      await ciz();
    }
    if (b.classList.contains('dr-ekle')) {
      b.disabled = true; b.textContent = '…';
      await fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ items: [{ id: +b.dataset.id, quantity: 1 }] }) });
      b.disabled = false; b.textContent = 'EKLE';
      await ciz();
    }
  });
  $('#drX').addEventListener('click', kapat);
  bg.addEventListener('click', kapat);
  document.addEventListener('keydown', (e) => { if (e.key === 'Escape' && dr.classList.contains('on')) kapat(); });
  // başlıktaki sepet ikonu çekmeceyi açar
  document.querySelectorAll('a.ib[href$="/cart"]').forEach((a) => a.addEventListener('click', (e) => { e.preventDefault(); ac(); }));
  // kapıda ödeme: EasySell formu varsa onu aç, yoksa Shopify ödeme sayfası
  const odeme = () => { const es = document.getElementById('es-popup-button'); if (!es) { location.href = '/checkout'; return; } kapat(); es.click(); };
  $('#drFt .dr-go').addEventListener('click', (e) => { e.preventDefault(); odeme(); });
  window.bvSepet = { ac, ciz, odeme };
  if (location.pathname === '/cart') fetch('/cart.js').then((r) => r.json()).then(duzenle).then((d) => d && location.reload());
})();

// ürün galerisi (bv-hollow, bv-urun): ana görseli parmakla sağa/sola kaydırınca sonraki/önceki küçük resim
(() => {
  const main = document.getElementById('main'), th = [...document.querySelectorAll('#thumbs button')];
  if (!main || th.length < 2) return;
  let x0, y0;
  main.addEventListener('touchstart', (e) => { x0 = e.touches[0].clientX; y0 = e.touches[0].clientY; }, { passive: true });
  main.addEventListener('touchend', (e) => {
    const dx = e.changedTouches[0].clientX - x0, dy = e.changedTouches[0].clientY - y0;
    if (Math.abs(dx) < 40 || Math.abs(dx) < Math.abs(dy)) return;
    const i = Math.max(0, th.findIndex((b) => b.getAttribute('aria-current') === 'true'));
    const b = th[(i + (dx < 0 ? 1 : th.length - 1)) % th.length];
    b.click();
    b.scrollIntoView({ block: 'nearest', inline: 'nearest' });
  }, { passive: true });
})();
